(ns app.components.buttons.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass]]))

(defclass icon
  [] {:height "16px"
      :width "16px"
      :display "block"})

(defclass icon-button-style
  [] {:padding "0px"
      :background "transparent"
      :border "none"
      :border-radius "8px"
      :height "24px"}
  [:&:hover
   {:background-color :theme/*purplePrimaryLight*}])

(defclass folder-item
  [] {:width "277px"
      :display "flex"
      :padding "8px"
      :align-items "center"
      :font-size "14px"
      :font-weight "700"
      :border "none"
      :background "white"
      :border-radius "8px"}
  [:&:hover
   {:background-color :theme/*purpleHoverThird*}]
  [:&:focus
   {:background :theme/*purplePrimaryLight*
    :color :theme/*purpleHover*
    :outline "none"}]
  [:&:active
   {:background :theme/*purplePrimaryLight*
    :color :theme/*purpleHover*
    :outline "none"}])

(defclass folder-item-of-untitled
  [name] {:width "277px"
          :display "flex"
          :padding "8px"
          :align-items "center"
          :font-size "14px"
          :font-weight "700"
          :border "none"
          :background "white"
          :color (if (= name "") :theme/*grey400* "black")
          :border-radius "8px"}
  [:&:hover
   {:background-color :theme/*purpleHoverThird*}] 
  [:&:active
   {:background :theme/*purplePrimaryLight*
    :color :theme/*purpleHover*
    :outline "none"}])

(defclass selected-folder-item
  [] {:width "277px"
      :display "flex"
      :padding "8px"
      :align-items "center"
      :font-size "14px"
      :font-weight "700"
      :border "none"
      :background :theme/*purplePrimaryLight*
      :color :theme/*purpleHover*
      :border-radius "8px"})

(defclass selected-folder-item-of-untitled
  [name] {:width "277px"
          :display "flex"
          :padding "8px"
          :align-items "center"
          :font-size "14px"
          :font-weight "700"
          :border "none"
          :background :theme/*purplePrimaryLight*
          :color (if (= name "") :theme/*grey400* :theme/*purpleHover*)
          :border-radius "8px"})


(defclass folder-list-header
  [] {:padding "8px"
      :align-items "center"
      :font-size "14px"
      :font-weight "700"
      :width "277px"})

(defclass xlarge-btn
  []
  {:font-size "21px"
   :font-weight "600"
   :color "white"
   :background-color :theme/*purplePrimary*
   :border-radius "4px"
   :border "1px solid"
   :border-color :theme/*purpleHover*
   :width "100%"
   :text-align "center"
   :min-height "60px"
   :padding "9px 24px"
   :cursor "pointer"}
  [:&:hover
   {:color "white"
    :background-color  :theme/*purpleHover*}]
  [:&:focus
   {:color "white"
    :background-color  :theme/*purpleActive*
    :outline "none"}]
  [:&:active
   {:color "white"
    :background-color  :theme/*purpleActive*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color "transparent"
    :outline "none"}])

(defclass large-btn
  []
  {:font-size "16px"
   :font-weight "600"
   :color "white"
   :background-color :theme/*purplePrimary*
   :border-radius "4px"
   :border "1px solid"
   :border-color :theme/*purpleHover*
   :width "100%"
   :text-align "center"
   :min-height "44px"
   :padding "9px 24px"
   :cursor "pointer"}
  [:&:hover
   {:color "white"
    :background-color  :theme/*purpleHover*}]
  [:&:focus
   {:color "white"
    :background-color  :theme/*purpleActive*
    :outline "none"}]
  [:&:active
   {:color "white"
    :background-color  :theme/*purpleActive*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color "transparent"
    :outline "none"}])

(defclass medium-btn
  []
  {:font-size "14px"
   :font-weight "600"
   :color "white"
   :background-color :theme/*purplePrimary*
   :border-radius "4px"
   :border "1px solid"
   :border-color :theme/*purpleHover*
   :padding "6px 24px 7px 24px"
   :width "100%"
   :display "flex"
   :justify-content "center"}
  [:&:hover
   {:color "white"
    :background-color  :theme/*purpleHover*}]
  [:&:focus
   {:color "white"
    :background-color  :theme/*purpleActive*
    :outline "none"}]
  [:&:active
   {:color "white"
    :background-color  :theme/*purpleActive*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color "transparent"
    :outline "none"}])

(defclass small-btn
  []
  {:font-size "12px"
   :font-weight "600"
   :color "white"
   :background-color :theme/*purplePrimary*
   :border-radius "4px"
   :border "1px solid"
   :border-color :theme/*purpleHover*
   :padding "6px 8px 7px 8px"}
  [:&:hover
   {:color "white"
    :background-color  :theme/*purpleHover*}]
  [:&:focus
   {:color "white"
    :background-color  :theme/*purpleActive*
    :outline "none"}]
  [:&:active
   {:color "white"
    :background-color  :theme/*purpleActive*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color "transparent"
    :outline "none"}])


(defclass xlarge-secondary-btn
  []
  {:font-size "21px"
   :font-weight "600"
   :background-color "white"
   :border-radius "4px"
   :border "1px solid"
   :padding "9px 24px"
   :border-color :theme/*dark98*
   :width "100%"
   :color :theme/*purplePrimary*
   :min-height "60px"}
  [:&:hover
   {:color :theme/*purple500*
    :border-color :theme/*purple500*
    :background-color  :theme/*purpleHoverSecondary*}]
  [:&:focus
   {:color :theme/*purpleHover*
    :border-color :theme/*purple500*
    :background-color  :theme/*purplePrimaryLightFocus*
    :outline "none"}]
  [:&:active
   {:color :theme/*purpleHover*
    :border-color :theme/*purple500*
    :background-color  :theme/*purplePrimaryLightFocus*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color :theme/*disabled*
    :outline "none"}])

(defclass large-secondary-btn
  []
  {:font-size "16px"
   :font-weight "600"
   :background-color "white"
   :border-radius "4px"
   :border "1px solid"
   :padding "9px 24px"
   :border-color :theme/*dark98*
   :width "100%"
   :color :theme/*purplePrimary*
   :min-height "44px"}
  [:&:hover
   {:color :theme/*purple500*
    :border-color :theme/*purple500*
    :background-color  :theme/*purpleHoverSecondary*}]
  [:&:focus
   {:color :theme/*purpleHover*
    :border-color :theme/*purple500*
    :background-color  :theme/*purplePrimaryLightFocus*
    :outline "none"}]
  [:&:active
   {:color :theme/*purpleHover*
    :border-color :theme/*purple500*
    :background-color  :theme/*purplePrimaryLightFocus*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color :theme/*disabled*
    :outline "none"}])

(defclass medium-secondar-btn
  []
  {:font-size "14px"
   :font-weight "600"
   :background-color "white"
   :border-radius "4px"
   :border "1px solid"
   :padding "6px 24px 7px 24px"
   :border-color :theme/*dark98*
   :color :theme/*purplePrimary*}
  [:&:hover
   {:color :theme/*purple500*
    :border-color :theme/*purple500*
    :background-color  :theme/*purpleHoverSecondary*}]
  [:&:focus
   {:color :theme/*purpleHover*
    :border-color :theme/*purple500*
    :background-color  :theme/*purplePrimaryLightFocus*
    :outline "none"}]
  [:&:active
   {:color :theme/*purpleHover*
    :border-color :theme/*purple500*
    :background-color  :theme/*purplePrimaryLightFocus*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color :theme/*disabled*
    :outline "none"}])

(defclass small-secondary-btn

  []
  {:font-size "12px"
   :font-weight "600"
   :background-color "white"
   :border-radius "4px"
   :border "1px solid"
   :padding "6px 8px 7px 8px"
   :border-color :theme/*dark98*
   :color :theme/*purplePrimary*}
  [:&:hover
   {:color :theme/*purple500*
    :border-color :theme/*purple500*
    :background-color  :theme/*purpleHoverSecondary*}]
  [:&:focus
   {:color :theme/*purpleHover*
    :border-color :theme/*purple500*
    :background-color  :theme/*purplePrimaryLightFocus*
    :outline "none"}]
  [:&:active
   {:color :theme/*purpleHover*
    :border-color :theme/*purple500*
    :background-color  :theme/*purplePrimaryLightFocus*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color :theme/*disabled*
    :outline "none"}])

(defclass large-third-btn
  []
  {:font-size "16px"
   :font-weight "600"
   :background-color "transparent"
   :text-decoration "underline"
   :border "none"
   :color :theme/*purplePrimary*}
  [:&:hover
   {:color :theme/*purpleHover*
    :text-decoration "underline"}]
  [:&:focus
   {:color :theme/*purpleActive*
    :text-decoration "underline"
    :outline "none"}]
  [:&:active
   {:color :theme/*purpleActive*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :text-decoration "underline"
    :outline "none"}])

(defclass medium-third-btn
  []
  {:font-size "14px"
   :font-weight "600"
   :background-color "transparent"
   :border "none"
   :text-decoration "underline"
   :color :theme/*purplePrimary*}
  [:&:hover
   {:color :theme/*purpleHover*
    :text-decoration "underline"}]
  [:&:focus
   {:color :theme/*purpleActive*
    :text-decoration "underline"
    :outline "none"}]
  [:&:active
   {:color :theme/*purpleActive*
    :text-decoration "underline"
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :text-decoration "underline"
    :outline "none"}])

(defclass small-third-btn
  []
  {:font-size "12px"
   :font-weight "600"
   :background-color "transparent"
   :border "none"
   :text-decoration "underline"
   :color :theme/*purplePrimary*}
  [:&:hover
   {:color :theme/*purpleHover*
    :text-decoration "underline"}]
  [:&:focus
   {:color :theme/*purpleActive*
    :text-decoration "underline"
    :outline "none"}]
  [:&:active
   {:color :theme/*purpleActive*
    :text-decoration "underline"
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :text-decoration "underline"
    :outline "none"}])


(defclass warning-large-btn
  []
  {:font-size "16px"
   :font-weight "600"
   :color "white"
   :background-color :theme/*redPrimary*
   :border-radius "4px"
   :border "1px solid"
   :border-color :theme/*redHover*
   :padding "9px 24px"}
  [:&:hover
   {:color "white"
    :background-color  :theme/*redHover*}]
  [:&:focus
   {:color "white"
    :background-color  :theme/*redActive*
    :outline "none"}]
  [:&:active
   {:color "white"
    :background-color  :theme/*redActive*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color "transparent"
    :outline "none"}])

(defclass warning-medium-btn
  []
  {:font-size "14px"
   :font-weight "600"
   :color "white"
   :background-color :theme/*redPrimary*
   :border-radius "4px"
   :border "1px solid"
   :border-color :theme/*redHover*
   :padding "6px 24px 7px 24px"}
  [:&:hover
   {:color "white"
    :background-color  :theme/*redHover*}]
  [:&:focus
   {:color "white"
    :background-color  :theme/*redActive*
    :outline "none"}]
  [:&:active
   {:color "white"
    :background-color  :theme/*redActive*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color "transparent"
    :outline "none"}])

(defclass warning-small-btn
  []
  {:font-size "12px"
   :font-weight "600"
   :color "white"
   :background-color :theme/*redPrimary*
   :border-radius "4px"
   :border "1px solid"
   :border-color :theme/*redHover*
   :padding "6px 8px 7px 8px"}
  [:&:hover
   {:color "white"
    :background-color  :theme/*redHover*}]
  [:&:focus
   {:color "white"
    :background-color  :theme/*redActive*
    :outline "none"}]
  [:&:active
   {:color "white"
    :background-color  :theme/*redActive*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color "transparent"
    :outline "none"}])

(defclass warning-large-secondary-btn
  []
  {:font-size "16px"
   :font-weight "600"
   :background-color "white"
   :border-radius "4px"
   :border "1px solid"
   :padding "9px 24px"
   :border-color :theme/*redPrimary*
   :color :theme/*redPrimary*}
  [:&:hover
   {:color :theme/*redPrimary*
    :border-color :theme/*redPrimary*
    :background-color  :theme/*redHoverSecondary*}]
  [:&:focus
   {:color :theme/*redPrimary*
    :border-color :theme/*redHover*
    :background-color  :theme/*redPrimaryLight*
    :outline "none"}]
  [:&:active
   {:color :theme/*redPrimary*
    :border-color :theme/*redHover*
    :background-color  :theme/*redPrimaryLight*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color :theme/*disabled*
    :outline "none"}])

(defclass warning-medium-secondary-btn
  []
  {:font-size "14px"
   :font-weight "600"
   :background-color "white"
   :border-radius "4px"
   :border "1px solid"
   :padding "6px 24px 7px 24px"
   :border-color :theme/*redPrimary*
   :color :theme/*redPrimary*}
  [:&:hover
   {:color :theme/*redPrimary*
    :border-color :theme/*redPrimary*
    :background-color  :theme/*redHoverSecondary*}]
  [:&:focus
   {:color :theme/*redPrimary*
    :border-color :theme/*redHover*
    :background-color  :theme/*redPrimaryLight*
    :outline "none"}]
  [:&:active
   {:color :theme/*redPrimary*
    :border-color :theme/*redHover*
    :background-color  :theme/*redPrimaryLight*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color :theme/*disabled*
    :outline "none"}])

(defclass warning-small-secondary-btn
  []
  {:font-size "12px"
   :font-weight "600"
   :background-color "white"
   :border-radius "4px"
   :border "1px solid"
   :padding "6px 8px 7px 8px"
   :border-color :theme/*redPrimary*
   :color :theme/*redPrimary*}
  [:&:hover
   {:color :theme/*redPrimary*
    :border-color :theme/*redPrimary*
    :background-color  :theme/*redHoverSecondary*}]
  [:&:focus
   {:color :theme/*redPrimary*
    :border-color :theme/*redHover*
    :background-color  :theme/*redPrimaryLight*
    :outline "none"}]
  [:&:active
   {:color :theme/*redPrimary*
    :border-color :theme/*redHover*
    :background-color  :theme/*redPrimaryLight*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*dark95*
    :border-color :theme/*disabled*
    :outline "none"}])

(defclass warning-large-third-btn
  []
  {:font-size "16px"
   :font-weight "600"
   :background-color "transparent"
   :text-decoration "underline"
   :border "none"
   :color :theme/*redPrimary*}
  [:&:hover
   {:color :theme/*redHover*
    :text-decoration "underline"}]
  [:&:focus
   {:color :theme/*redActive*
    :text-decoration "underline"
    :outline "none"}]
  [:&:active
   {:color :theme/*redActive*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :text-decoration "underline"
    :outline "none"}])

(defclass warning-medium-third-btn
  []
  {:font-size "14px"
   :font-weight "600"
   :background-color "transparent"
   :text-decoration "underline"
   :border "none"
   :color :theme/*redPrimary*}
  [:&:hover
   {:color :theme/*redHover*
    :text-decoration "underline"}]
  [:&:focus
   {:color :theme/*redActive*
    :text-decoration "underline"
    :outline "none"}]
  [:&:active
   {:color :theme/*redActive*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :text-decoration "underline"
    :outline "none"}])

(defclass warning-small-third-btn
  []
  {:font-size "12px"
   :font-weight "600"
   :background-color "transparent"
   :text-decoration "underline"
   :border "none"
   :color :theme/*redPrimary*}
  [:&:hover
   {:color :theme/*redHover*
    :text-decoration "underline"}]
  [:&:focus
   {:color :theme/*redActive*
    :text-decoration "underline"
    :outline "none"}]
  [:&:active
   {:color :theme/*redActive*
    :outline "none"}]
  [:&:disabled
   {:color :theme/*disabled*
    :text-decoration "underline"
    :outline "none"}])

(defclass statistics-tab-selector-selected-style
  []
  {:background-color :theme/*purplePrimaryLight*
   :color :theme/*purplePrimary*
   :border-radius "4px"
   :padding "8px 54px 8px 54px"
   :border "0px "
   :justify-content :end}
  [:&:hover
   {:background-color :theme/*purplePrimaryLight*}])


(defclass statistics-tab-selector-not-selected-style
  []
  {:background-color "white"
   :border-radius "4px"
   :padding "8px 54px 8px 54px"
   :border "0px "
   :justify-content :end
   }
  [:&:hover
   {:background-color :theme/*purplePrimaryLight*}])
